import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import moment from "moment"
import Breadcrumb from "components/Common/Breadcrumb2"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
  UncontrolledTooltip,
} from "reactstrap"
import { withTranslation } from "react-i18next"
import {
  createStatusSafra,
  deleteStatusSafra,
  getAllStatusSafra,
  restoreStatusSafra,
  updateStatusSafra,
} from "services/shipping-events/calls"

import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import toast from "components/Toast/Toast"

const StatusSafra = props => {
  document.title = "Cadastro de Status Safra | Sensetek"
  moment.locale("pt-br")
  const { t } = props

  const [isLoading, setIsLoading] = useState(true)
  const [statusSafra, setStatusSafra] = useState()
  const [statusSafraOrders, setStatusSafraOrders] = useState()

  const [novoStatusSafra, setNovoStatusSafra] = useState({
    name: "",
    orderInTable: "",
  })
  const [updatedStatusSafra, setUpdatedStatusSafra] = useState({
    name: "",
    orderInTable: "",
  })

  const [confirm, setConfirm] = useState({})
  const [showConfirm, setShowConfirm] = useState(false)
  const [modalUpdateStatusSafra, setModalUpdateStatusSafra] = useState(false)

  const selectRow = {
    mode: "checkbox",
    hideSelectColumn: true,
  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  const columns = [
    {
      dataField: "id",
      text: "#",
      sort: false,
      headerStyle: {
        width: "50px",
      },
      formatter: (cellContent, row) => <b>{cellContent}</b>,
    },
    {
      dataField: "name",
      text: "Nome",
      sort: false,
    },
    {
      dataField: "orderInTable",
      text: "Ordem",
      sort: false,
    },
    {
      dataField: "createdBy.name",
      text: "Criado Por",
      sort: false,
      formatter: (cellContent, row) => (cellContent ? cellContent : "Sistema"),
    },
    {
      dataField: "actions",
      isDummyField: true,
      text: "Ações",
      headerAlign: "center",
      align: "center",
      headerStyle: (colum, colIndex) => {
        return { width: "10%", textAlign: "center" }
      },
      formatter: (cellContent, row) => (
        <ul className="list-unstyled hstack gap-1 mb-0 justify-content-center">
          <li>
            <a
              target="_blank"
              className={`btn btn-sm btn-primary`}
              onClick={() => {
                setUpdatedStatusSafra(row)
                setModalUpdateStatusSafra(true)
              }}
            >
              <i
                className="mdi mdi-account-edit"
                id={`altToolTip${row.id}`}
              ></i>
            </a>
            <UncontrolledTooltip placement="top" target={`altToolTip${row.id}`}>
              Alterar
            </UncontrolledTooltip>
          </li>
          <li>
            <a
              target="_blank"
              className={`btn btn-sm btn-${
                row.deletedAt ? "secondary" : "danger"
              }`}
              onClick={async () => {
                if (row.deletedAt) {
                  try {
                    setIsLoading(true)
                    await restoreStatusSafra(row.id)
                    fetchAllStatusSafra()
                    toast("success", "Status Safra ativado com sucesso!")
                  } catch (error) {
                    toast("warning", "Falha ao ativar Status Safra.")
                    console.log(error)
                  } finally {
                    setIsLoading(false)
                  }
                } else {
                  setConfirm({
                    title: "Confirmação",
                    body: (
                      <div>
                        <p>
                          Esta ação ira desabilitar esta opção de Status Safra.
                        </p>
                        <p>
                          Por favor, confirme se tem certeza que deseja
                          desabilitar este Status Safra?
                        </p>
                      </div>
                    ),
                    onConfirm: async () => {
                      setIsLoading(true)
                      try {
                        await deleteStatusSafra(row.id)
                        fetchAllStatusSafra()
                        toast("success", "Status Safra desativado com sucesso!")
                      } catch (error) {
                        toast("warning", "Falha ao desativar Status Safra.")
                        console.log(error)
                      } finally {
                        setIsLoading(false)
                      }
                    },
                  })
                  setShowConfirm(true)
                }
              }}
            >
              <i
                className={`mdi mdi-${
                  row.deletedAt ? "account-reactivate" : "delete-forever"
                }`}
                id={`delToolTip${row.id}`}
              ></i>
            </a>
            <UncontrolledTooltip placement="top" target={`delToolTip${row.id}`}>
              {`${row.deletedAt ? "Reativar" : "Desativar"}`}
            </UncontrolledTooltip>
          </li>
        </ul>
      ),
    },
  ]

  const fetchAllStatusSafra = async () => {
    try {
      setIsLoading(true)
      const { statusSafra } = await getAllStatusSafra()
      setStatusSafra(statusSafra)
      setStatusSafraOrders(statusSafra.map(e => e?.orderInTable))
      setNovoStatusSafra(old => {
        return {
          ...old,
          orderInTable: Math.max(...statusSafra.map(e => e?.orderInTable)) + 1,
        }
      })
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    try {
      fetchAllStatusSafra()
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }, [])

  const handleSubmit = async e => {
    e.preventDefault()
    setIsLoading(true)
    try {
      if (novoStatusSafra.name) {
        try {
          await createStatusSafra(novoStatusSafra)
          setNovoStatusSafra({
            name: "",
            orderInTable: "",
          })
          fetchAllStatusSafra()
          toast("success", "Status Safra adicionado com sucesso!")
        } catch (error) {
          console.error(error)
          toast("error", "Falha ao adicionar Status Safra")
        }
      } else {
        toast(
          "warning",
          "Não é possível adicionar Status Safra com nome vazio."
        )
      }
    } catch (error) {
      toast("warning", "Falha ao criar canal.")
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleUpdateStatusSafra = async e => {
    e.preventDefault()
    if (updateStatusSafra.name) {
      try {
        setIsLoading(true)
        await updateStatusSafra(updatedStatusSafra.id, updatedStatusSafra)
        fetchAllStatusSafra()
        toast("success", "Status Safra atualizado com sucesso!")
      } catch (error) {
        toast("warning", "Falha ao alterar Status Safra.")
        console.log(error)
      } finally {
        setIsLoading(false)
      }
      setModalUpdateStatusSafra(false)
    } else {
      toast(
        "warning",
        "Não é possível atualizar o nome do Status Safra para vazio."
      )
    }
  }

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Configurações")}
            breadcrumbItems={[{ title: props.t("Status Safra"), path: "#" }]}
          />
          <Row>
            <Col>
              <Card className="mb-0">
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  {t("Adicionar")}
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col sm={8}>
                        <FormGroup>
                          <br></br>
                          <Label>{t("Nome do Status Safra")}</Label>
                          <Input
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder="Status Safra"
                            disabled={isLoading}
                            value={novoStatusSafra.name}
                            onChange={e => {
                              setNovoStatusSafra(old => {
                                return { ...old, name: e.target.value }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={2}>
                        <FormGroup>
                          <br></br>
                          <Label>{t("Ordem de Apresentação")}</Label>
                          <Input
                            name="orderInTable"
                            type="number"
                            className="form-control"
                            placeholder="Ordem"
                            disabled={isLoading}
                            min={1}
                            value={novoStatusSafra.orderInTable}
                            onChange={e => {
                              let val = parseInt(e.target.value, 10)
                              if (isNaN(val)) {
                                setNovoStatusSafra(old => {
                                  return {
                                    ...old,
                                    orderInTable: "",
                                  }
                                })
                              } else {
                                val =
                                  val >= 0
                                    ? val
                                    : Math.max(...statusSafraOrders) + 1
                                if (isNaN(val)) {
                                  setNovoStatusSafra(old => {
                                    return {
                                      ...old,
                                      orderInTable:
                                        Math.max(...statusSafraOrders) + 1,
                                    }
                                  })
                                } else {
                                  setNovoStatusSafra(old => {
                                    return { ...old, orderInTable: val }
                                  })
                                }
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col className="d-flex align-items-end">
                        <FormGroup>
                          <Button type="submit">{t("Adicionar")}</Button>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  Lista de Status Safra
                </CardHeader>
                <CardBody>
                  {!isLoading && statusSafra?.length > 0 ? (
                    <ToolkitProvider
                      keyField="id"
                      columns={columns}
                      columnToggle
                      data={statusSafra}
                      search
                    >
                      {toolkitProps => (
                        <React.Fragment>
                          <Row>
                            <Col xl="12">
                              <BootstrapTable
                                keyField={"id"}
                                bordered={true}
                                striped={true}
                                condensed
                                defaultSorted={defaultSorted}
                                selectRow={selectRow}
                                classes={"table align-middle table-nowrap"}
                                headerWrapperClasses={"thead-light"}
                                {...toolkitProps.baseProps}
                              />
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
                  ) : (
                    <div style={{ textAlign: "center" }}>
                      <h5>Nenhum dado foi encontrado.</h5>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={showConfirm}
        toggle={() => {
          setShowConfirm(!showConfirm)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>{confirm?.title}</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              {
                confirm
              }
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">{confirm?.body}</div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {t("Cancelar")}
          </button>
          <button
            type="button"
            onClick={async () => {
              await confirm?.onConfirm()
              setShowConfirm(false)
            }}
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {t("Confirmar")}
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={modalUpdateStatusSafra}
        toggle={() => {
          setModalUpdateStatusSafra(!modalUpdateStatusSafra)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>Atualizar Status Safra</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setModalUpdateStatusSafra(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleUpdateStatusSafra} id="updateStatusSafra">
            <Row>
              <Col>
                <Label>{t("Novo Nome")}</Label>
                <Input
                  type="text"
                  className="form-control"
                  disabled={isLoading}
                  value={updatedStatusSafra.name}
                  onChange={e => {
                    setUpdatedStatusSafra(old => {
                      return { ...old, name: e.target.value }
                    })
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Label>{t("Nova Posição")}</Label>
                <Input
                  type="number"
                  className="form-control"
                  disabled={isLoading}
                  value={updatedStatusSafra.orderInTable}
                  onChange={e => {
                    let val = parseInt(e.target.value, 10)
                    if (isNaN(val)) {
                      setUpdatedStatusSafra(old => {
                        return {
                          ...old,
                          orderInTable: "",
                        }
                      })
                    } else {
                      val = val >= 0 ? val : Math.max(...statusSafraOrders) + 1
                      if (isNaN(val)) {
                        setUpdatedStatusSafra(old => {
                          return {
                            ...old,
                            orderInTable: Math.max(...statusSafraOrders) + 1,
                          }
                        })
                      } else {
                        setUpdatedStatusSafra(old => {
                          return { ...old, orderInTable: val }
                        })
                      }
                    }
                  }}
                ></Input>
              </Col>
            </Row>
          </Form>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setModalUpdateStatusSafra(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {t("Cancelar")}
          </button>
          <button
            type="submit"
            form="updateStatusSafra"
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {t("Confirmar")}
          </button>
        </div>
      </Modal>
    </>
  )
}

StatusSafra.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(StatusSafra)
